import styles from "./ChatMode.module.scss"

import React, { MouseEvent } from "react"

import { MessagesProvider, useChatInfo, useSchedule } from "@shared/contexts"
import { useWatchingSchedule } from "@shared/hooks"

import { Messages } from "chatMode/components"
import classNames from "classnames"

export default function ChatMode() {
  const { schedule } = useSchedule()
  const { isSearchBarEnabled, chatMenu } = useChatInfo()

  const isManagerGroup = chatMenu === "MANAGER"

  useWatchingSchedule()

  return (
    <article className="popup max">
      <div className="titB">
        <h1>{schedule?.title}</h1>
        <a
          href="#!"
          onClick={(e: MouseEvent) => {
            e.preventDefault()
            window.close()
          }}
          title="닫기"
        >
          닫기
        </a>
      </div>
      <div
        style={{paddingBottom: chatMenu === "USER" ? 116 : 70}}
        className={classNames("txtB type01", {
          [styles.deactiveSearch]: !isSearchBarEnabled,
        })}
      >
        <MessagesProvider limitCount={100}>
          <Messages />
        </MessagesProvider>
      </div>
    </article>
  )
}
